module.exports = __webpack_public_path__ + "jsj_h5_static/img/no_list.da276dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/base/no_list.png
// module id = NOOp
// module chunks = 36